import { render, staticRenderFns } from "./superdocument-add-or-update.vue?vue&type=template&id=2c136a8b&scoped=true&"
import script from "./superdocument-add-or-update.vue?vue&type=script&lang=js&"
export * from "./superdocument-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./superdocument-add-or-update.vue?vue&type=style&index=0&id=2c136a8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c136a8b",
  null
  
)

export default component.exports